import { makeAutoObservable } from "mobx";
import { IUsers } from "../models/IUsers";
import UsersService from "../service/UsersService";
import { showErrorToast, showSuccessToast } from "../components/toasts";

export default class Users {
  UsersList: IUsers[] = [];
  loadingUsersBool: boolean = false;
  usersFilters: string[] = [];
  selectedUser: IUsers = {} as IUsers;

  constructor() {
    makeAutoObservable(this);
  }

  setSelectedUser(user: IUsers) {
    this.selectedUser = user;
    localStorage.setItem("user", JSON.stringify(this.selectedUser._id));
  }

  setUsersFilter(status: string[], isFromFilter: boolean = true) {
    this.usersFilters = status;
    if (isFromFilter) {
      localStorage.setItem("userStatus", JSON.stringify(status));
    }
  }

  setUsersList(eventList: IUsers[]) {
    this.UsersList = eventList;
  }

  loadSelectedUser() {
    if (this.UsersList.length > 0) {
      const data = localStorage.getItem("user");
      if (data !== null) {
        const userData = this.UsersList.find(
          (user) => user._id === JSON.parse(data)
        );
        if (userData !== undefined) this.loadOne(userData._id);
      }
    }
  }

  async loadList() {
    this.loadingUsersBool = true;
    const userList = await UsersService.fetchList(this.usersFilters);
    this.setUsersList(userList.data.users);
    this.loadingUsersBool = false;
    return userList.data.users;
  }

  async loadOne(id: string | undefined) {
    if(!id) return null
    this.loadingUsersBool = true;
    const user = await UsersService.fetchOne(id);
    this.setSelectedUser(user.data);
    this.loadingUsersBool = false;
    return user.data
  }

  async updateUser(data: IUsers | undefined) {
    this.loadingUsersBool = true;
    if (typeof data !== "undefined") {
      await UsersService.fetchUpdateOne(data);
      const userData = await this.loadList();
      return userData;
    } else {
      console.log("no data to update");
    }
    this.loadingUsersBool = false;
  }

  async fetchStatistics() {
    const statistics = await UsersService.fetchStatistics();
    return statistics?.data;
    // return statistics.data;
  }

  async updateUserDoc(data: any) {
    const res = await UsersService.updateDoc(data);
    return res.data;
  }

  // TODO: Admin doc Method 
  async uploadAdminDocument(data: any){
    try {
      const rest = await UsersService.uploadAdminDoc(data);
      return rest.data
    } catch (error) {
      console.log(error)
    }
  }

  async updateAdminDocument(data: any){
    try {
      const rest = await UsersService.updateAdminDoc(data);
      return rest.data
    } catch (error) {
      console.log(error)
    }
  }

  async deleteAdminDocument(data: any){
    try {
      const rest = await UsersService.deleteAdminDoc(data);
      return rest.data
    } catch (error) {
      console.log(error)
    }
  }

  //TODO: calc delete data method
  
  async calcDeleteData(data: any){
    try {
      const rest = await UsersService.calcDeleteData(data);
      return rest.data
    } catch (error) {
      console.log(error)
    }
  }

  async fetchEnquiry() {
    const enquiry = await UsersService.fetchUserEnquiry();
    return enquiry?.data;
  }

  async deleteEnquiry(id: any) {
    const enquiry = await UsersService.deleteUserEnquiry(id);
    return enquiry?.data;
  }

  async updateUserProfile(id: string, data: any) {
    try {
      const rest = await UsersService.userProfile(id, data);
      showSuccessToast("Updated User Profile Successfully!")
      return rest.data
    } catch (error: any) {
      showErrorToast(error?.response?.data?.error || error?.response?.data?.error.message)
    }
  }
  
  async deleteUserApplications(index:number) {
    try {
      const rest = await UsersService.deleteAppliction(index);
      showSuccessToast("User Application Deleted Successfully!")
      return rest
    } catch (error: any) {
      showErrorToast(error?.response?.data?.error || error?.response?.data?.error.message)
    }
  }


}
